module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0vii-01.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2d"
  }, [_c('strong', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/frontmatter02"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("FOREWORD BY MALCOLM MARGOLIN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/frontmatter03"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("PREFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("THE SWAN OF ERIN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Enduring Legacy of Kate Hayes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#sec1"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" Jenny Lind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("THREE MONTHS ALONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Ordeal of Moses Schallenberger")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" The Stephens-Townsend-Murphy Party")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("A BROAD, HARD-BEATEN ROAD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Melissa Coray and the Mormon Battalion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" George Stoneman")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("MORE BEAUTIFUL THAN THE ORIGINAL")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Albert Bierstadt")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" William Keith")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("FEARFUL SYMMETRY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Native Americans in Early California")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" Judith Lowry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("SOLID GOLD FISHHOOKS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Gold Lake Excitement of 1850")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" E Clampus Vitus")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("THE SPIDER DANCER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Lola Montez")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" Adah Isaacs Menken")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("THE ETERNAL CHILD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Lotta Crabtree")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" Kate and Ellen Bateman")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("SACAGAWEA’S SON")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Adventures of Pompy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" Joseph B. Starkweather")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("JUST TO PROVE A POINT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Fall of the Forest Monarchs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" The General Noble Tree")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("THE ULTIMATE THRILL")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Great Flume Ride of 1875")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" The Incline")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("TWENTY-THREE MILES IN SEVEN DAYS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The 1911 Tahoe Tavern Automobile Race")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" Alice Huyler Ramsey")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("CURIOUS CARAVAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Edward Fitzgerald Beale and the Camel Corps")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" Otto Esche’s Camel Express")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("THE FORGOTTEN VISIONARY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Theodore Judah")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" The Bloomer Cut")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("HALFWAY TO THE STARS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Andrew Hallidie")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" The Emerald Bay Bridge")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("HIDDEN HISTORY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("African Americans in the Sierra Nevada")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" Charles Young and the Buffalo Soldiers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("DAWN AND DARKNESS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Gold Mountain and the Chinese")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" Yee Fung Cheung and the Chew Kee Store")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("INSTRUMENTS OF DARKNESS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Chinese Exclusion Act of 1882")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" The Truckee Method")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("POWER COUPLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Sargents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" Aaron A. Sargent and the Chinese Exclusion Act")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("PHOTOGRAPHIC MEMORY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Eadweard Muybridge")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" Carleton Watkins")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("THE UNKNOWN ARCHITECT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("John Conness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" Galen Clark")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("GLORIOUS STARRY FIRMAMENT FOR A ROOF")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Pioneering Yosemite Rock Climbers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" A. Phimister Proctor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("THE FIRST LIGHT OF EVENING")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Folsom Powerhouse")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" French Corral and the Telephone")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("MAGNIFICENT SCOUNDREL")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Lucky Baldwin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" The State Line Country Club")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("MINGO, BILL, AND THE CAPTAIN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("George Whittell, Jr., and the Thunderbird Lodge")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#sec25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" Vikingsholm")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("THE PHANTOM FOUNTAIN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Thomas Hill")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26#sec26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" Thomas Moran")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("THE LITTLE TRAMP IN TRUCKEE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Charlie Chaplin and "), _c('em', [_vm._v("The Gold Rush")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#sec27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight: Greed")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("REEL-LIFE EXPERIENCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Railtown and the Alabama Hills")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#sec28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" The Sierra Nevada as Somewhere Else")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("SOUL-CONSOLING TOWER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Manzanar")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#sec29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" The 442nd Regimental Combat Team")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("BEHOLD THE WANDERING MOON")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Wakamatsu Tea and Silk Colony")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#sec30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" Burnette Haskell and the Kaweah Colony")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("STOVELEG PITONS AND CHEAP RED WINE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Warren Harding and El Capitan")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31#sec31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" Alex Honnold")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("LIKE A ROLLERCOASTER, ONLY ROUGHER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Tioga Pass Road")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32#sec32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('em', [_vm._v("Sierra Spotlight:")]), _vm._v(" The Snowshed Highway")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("SELECTED BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("ABOUT THE AUTHOR")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 72
// module chunks = 0